import { makeImage } from "../utils";
import posTerminal from "./pos-terminal.svg";

export const PosTerminal = makeImage({
  src: posTerminal,
  width: 264,
  height: 156,
  dataTestId: "pos-terminal",
});
